export function Field({ label, children }) {
  return (
    <div className="space-y-1.5">
      <label className="data-label block">{label}</label>
      {children}
    </div>
  );
}
